/* 

Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.

*/

import { Button, ButtonProps, FormControlLabel, Radio, RadioGroup, styled } from '@mui/material';
import DefaultModal from './DefaultModal';
import { OTPMethod, useLoginContext } from '../../contexts/LoginContext';
import Styles from '../../css/ChooseOTPModal.module.css';

import { useAuthContext } from '../../contexts/AuthContext';

import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import EmailIcon from '@mui/icons-material/Email';

const ColorButton = styled(Button)<ButtonProps>(({ theme }) => ({
  fontWeight: 'bold',
}));

const ChooseOTPModal = () => {
  const {
    showChooseOTPModal,
    setShowChooseOTPModal,
    sendOTP,
    setAuthenticationMethod,
    authenticationMethod,
    hiddenEmailAddress,
    setLoginModalOpen,
  } = useLoginContext();

  const { phoneNo } = useAuthContext();

  const cssforphonebutton = authenticationMethod == OTPMethod.PHONE ? 'outlined' : 'text';
  const cssforemailbutton = authenticationMethod == OTPMethod.EMAIL ? 'outlined' : 'text';

  return (
    <DefaultModal
      open={showChooseOTPModal}
      content={
        <>
          <h1 className={Styles.title}>Choose OTP Method</h1>
          <div className={Styles.otps}>
            {
              <>
                <Button
                  title='Send Authentication code by Phone'
                  variant={cssforphonebutton}
                  className={authenticationMethod == OTPMethod.PHONE ? Styles.contactdivselected : Styles.contactdiv}
                  onClick={() => setAuthenticationMethod(OTPMethod.PHONE)}
                  startIcon={<PhoneIphoneIcon></PhoneIphoneIcon>}
                  fullWidth={true}
                >
                  {'TEXT (***)-***-**' + phoneNo.slice(-2)}
                </Button>
                <Button
                  title='Send Authentication code by Email'
                  variant={cssforemailbutton}
                  className={authenticationMethod == OTPMethod.EMAIL ? Styles.contactdivselected : Styles.contactdiv}
                  onClick={() => setAuthenticationMethod(OTPMethod.EMAIL)}
                  startIcon={<EmailIcon></EmailIcon>}
                  fullWidth={true}
                >
                  {'EMAIL ' + hiddenEmailAddress}
                </Button>
              </>
            }
          </div>
        </>
      }
      footer={
        <div className={Styles.footer}>
          <Button className={Styles.cancelbutton} onClick={() => setShowChooseOTPModal(false)}>
            Cancel
          </Button>
          <ColorButton
            variant='contained'
            className={Styles.sendotpbutton}
            onClick={() => {
              sendOTP();
            }}
          >
            Send OTP
          </ColorButton>
        </div>
      }
    />
  );
};

export default ChooseOTPModal;
